import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { PersonListParams } from './Candidate.type';
import {
  PersonCreateFetch,
  PersonMergeFetch,
  PersonMergeWithDataFetch,
  PersonUpdateFetch,
} from './Experience/PersonExperience.type';
import { getDateTime } from '../../services/date.service';
import { DATE_YEAR_MONTH_DAY_FORMAT } from '../../constants/date.contant';

let metaRequest: any = null;
let listRequest: any = null;
let infoRequest: any = null;

const CandidateService = {
  getMeta: (region: number[] | undefined) => {
    metaRequest && metaRequest.cancel();
    metaRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase('people/meta'), {
      cancelToken: metaRequest.token,
      params: {
        filter: {
          region,
        },
      },
    });
  },
  getList: (params: PersonListParams) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase('people'), {
      cancelToken: listRequest.token,
      params: {
        search: params.search,
        filter: {
          region: params.region,
          tab: params.tab,
          ...params.filter,
          dateRange: params.filter
            ? params.filter.dateRange
              ? `${getDateTime(
                  params.filter.dateRange.start,
                  DATE_YEAR_MONTH_DAY_FORMAT,
                )}:${getDateTime(
                  params.filter.dateRange.end,
                  DATE_YEAR_MONTH_DAY_FORMAT,
                )}`
              : undefined
            : undefined,
          selectAll: params.filter?.selectAll ? undefined : '1',
        },
        page_size: params.pageSize,
        page: params.page || 1,
        sort: params.sort,
      },
    });
  },
  getPreviewInfo(id: number | string, options: any = {}) {
    infoRequest && infoRequest.cancel();
    infoRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`people/${id}/preview`), {
      cancelToken: infoRequest.token,
      ...options,
    });
  },
  getPreviewInfoIsolated(id: number | string) {
    return axios.get(getEndpointBase(`people/${id}/preview`));
  },
  getInfo(id: number | string) {
    infoRequest && infoRequest.cancel();
    infoRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`people/${id}`), {
      cancelToken: infoRequest.token,
    });
  },
  check(params: PersonCreateFetch) {
    return axios.post(getEndpointBase(`people/check`), {
      ...params,
    });
  },
  merge(targetId: number | string, params: PersonMergeFetch) {
    return axios.put(getEndpointBase(`people/merge/${targetId}`), {
      ...params,
    });
  },
  mergeWithData(params: PersonMergeWithDataFetch) {
    return axios.put(getEndpointBase(`people/merge-with-data/${params.id}`), {
      ...params,
    });
  },
  store(params: PersonCreateFetch) {
    return axios.post(getEndpointBase(`people`), {
      ...params,
    });
  },
  update({ id, ...params }: PersonUpdateFetch) {
    return axios.put(getEndpointBase(`people/${id}`), {
      ...params,
    });
  },
  destroy(id: number | string) {
    return axios.delete(getEndpointBase(`people/${id}`));
  },
};

export default CandidateService;
